import React from "react";
import { Modal, Form, Input, message } from "antd";
import { InvoiceService } from "../../../services/Invoices/InvoiceService/InvoiceService";

interface Props {
	open: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

const AddReferrerModal: React.FC<Props> = ({ open, onClose, onSuccess }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false);

	const handleSubmit = async () => {
		try {
			const values = await form.validateFields();

			setLoading(true);

			await InvoiceService.addReferrer({
				name: values.name,
				email: values.email
			});

			message.success("Referrer added successfully");

			form.resetFields();
			onClose();
			onSuccess();

		} catch (error: any) {
			message.error(error?.response?.data?.message || "Failed to add referrer");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title="Add Referrer"
			open={open}
			onCancel={onClose}
			onOk={handleSubmit}
			confirmLoading={loading}
			okText="Add"
		>
			<Form form={form} layout="vertical">
				<Form.Item
					label="Name"
					name="name"
					rules={[{ required: true, message: "Name is required" }]}
				>
					<Input placeholder="Enter name" />
				</Form.Item>

				<Form.Item
					label="Email"
					name="email"
					rules={[{ type: "email", message: "Enter valid email" }]}
				>
					<Input placeholder="Enter email" />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default AddReferrerModal;